import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";
import { popularTags } from "@/lib/nav";

interface SidebarProps {
  activeType?: string;
}

export default function Sidebar({ activeType }: SidebarProps) {
  const { pathname } = useLocation();

  const countOf = (type: string) =>
    articles.filter((item) => item.category === type).length;

  return (
    <aside className="w-full lg:w-[268px] lg:shrink-0">
      <div className="lg:sticky lg:top-20 flex flex-col gap-5">
        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-950">
            <span className="w-5 h-5 flex items-center justify-center text-primary-600">
              <i className="ri-layout-grid-line text-base" />
            </span>
            内容分类
          </h3>
          <nav className="flex flex-col gap-1">
            {categories.map((category) => {
              const active = activeType === category.type;
              return (
                <Link
                  key={category.type}
                  to={`/category/${category.type}`}
                  className={[
                    "flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors",
                    active
                      ? "bg-primary-600 text-background-50"
                      : "text-foreground-700 hover:bg-background-100",
                  ].join(" ")}
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${category.icon} text-base`} />
                  </span>
                  <span className="flex-1">{category.name}</span>
                  <span
                    className={[
                      "rounded-full px-2 py-0.5 text-xs",
                      active
                        ? "bg-background-50/20 text-background-50"
                        : "bg-background-200 text-foreground-600",
                    ].join(" ")}
                  >
                    {countOf(category.type)}
                  </span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-950">
            <span className="w-5 h-5 flex items-center justify-center text-secondary-600">
              <i className="ri-price-tag-3-line text-base" />
            </span>
            热门标签
          </h3>
          <div className="flex flex-wrap gap-2">
            {popularTags.map((tag) => (
              <Link
                key={tag}
                to={`/search?q=${encodeURIComponent(tag)}`}
                className="rounded-full bg-secondary-50 px-3 py-1 text-xs text-secondary-800 transition-colors hover:bg-secondary-100"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
          <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold text-accent-800">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-alert-line text-base" />
            </span>
            重要提示
          </h3>
          <p className="text-xs leading-relaxed text-accent-900/80">
            本网站内容为法律与伦理知识科普，示例为虚构或公开法规整理，不构成法律意见。如遇现实困境，请及时联系警方或专业机构。
          </p>
        </div>

        {pathname === "/search" && (
          <div className="rounded-lg border border-background-200 bg-background-50 p-4">
            <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <span className="w-5 h-5 flex items-center justify-center text-primary-600">
                <i className="ri-compass-3-line text-base" />
              </span>
              搜索小贴士
            </h3>
            <ul className="space-y-2 text-xs text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600" />
                使用具体关键词，如“禁婚亲属”“知情同意”
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600" />
                切换分类标签可缩小检索范围
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600" />
                结果按相关度排序，标题命中优先
              </li>
            </ul>
          </div>
        )}
      </div>
    </aside>
  );
}